import { Theme } from '@/theme';
import Button from '@CS/components/Button';
import styled, { css } from 'styled-components';

export const FamilyMemberContainer = styled.div`
  justify-content: space-between;
  background-color: #ebebeb;

  align-items: center;
  position: relative;

  margin-bottom: 8px;
  border-radius: 8px;

  display: flex;
  padding: 8px;

  height: 64px;
  width: 100%;
  gap: 8px;

  &:last-child {
    margin-bottom: 0px;
  }
`;

type FamilyMemberPreviewContainerAttributes = {
  backgroundColor: string;
};

export const FamilyMemberPreviewContainer = styled.div(
  ({ backgroundColor }: FamilyMemberPreviewContainerAttributes) => css`
    ${backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}

    border-radius: 8px;

    min-height: 48px;
    max-height: 48px;

    min-width: 48px;
    max-width: 48px;

    > img {
      object-fit: cover;
      aspect-ratio: 1;
      width: 100%;
    }
  `
);

export const FamilyMemberName = styled.h5`
  font-weight: ${Theme.font.weight.regular};
  font-size: ${Theme.rems(16)};

  overflow-wrap: anywhere;
  word-break: break-all;

  line-height: 1.4;
  flex-grow: 1;
  // height: 18px;
`;

export const ButtonsContainer = styled.div`
  min-height: 40px;
  max-height: 40px;

  min-width: 88px;
  max-width: 88px;
`;

export const TrashButton = styled(Button)`
  margin-right: 8px;
`;
